import { ColoursObj, Typography } from '@eventr/common-storybook'
import { Box, Checkbox } from '@mui/material'
import i18n from '../../../i18n/i18next'
interface ISelectAllBoxProps {
    query: string
    allUsers: any
    allSelected: boolean
    onClick: () => void
}
export const SelectAllBox = ({
    onClick,
    query,
    allSelected,
    allUsers,
}: ISelectAllBoxProps) => {
    return (
        <>
            {query.length === 0 && (
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'auto 1fr auto',
                        alignItems: 'center',
                        width: '100%',
                        gap: '8px',
                        backgroundColor: ColoursObj.backgrounds.secondary,
                        borderRadius: '8px',
                    }}
                    onClick={onClick}
                >
                    <Box>
                        <Checkbox
                            id={'edit-members-select-all-checkbox'}
                            checked={allSelected}
                            sx={{ color: ColoursObj.core.primary }}
                        />
                    </Box>

                    <Box>
                        <Typography variant="bodyBold">
                            {i18n.t('edit-members.select-all')}
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            margin: '8px',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            background: ColoursObj.backgrounds.card,
                        }}
                    >
                        <Typography variant="bodyRegular">
                            {allUsers.length ?? '0'}
                        </Typography>
                    </Box>
                </div>
            )}
        </>
    )
}
